import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, useParams } from 'react-router-dom';
import Axios from '../../../axios/axios';
import { Header } from '../../../components/SpearParts/Layouts/Header';
import { Footer } from '../../../components/SpearParts/Layouts/Footer';
import ConfettiButton from '../../../components/Alert/OrderSuccess';
import { toTitleCase } from '../../../components/utils/StringUtil';
import AlertModal from '../../../actions/AlertModal';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';



function Delivery() {
    const [isLoad, setIsLoad] =useState(false)
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
    const businessType = sessionStorage.getItem("businessType");
    const [customer, setCustomer] = useState({
        customerName: "",
        phoneNumber: "",
        email:"",
        username:"",
        gstNumber: "",
        address: "",
        country: "",
        state: "",
        city: "",
        pincode: "",
        bankName:"",
        bankAddress:"",
        accountNumber:"",
        currency:"",
        ibanNumber:"",
        swift:"",

    });

    const [editableFields, setEditableFields] = useState({}); 
    const [shippingOption, setShippingOption] = useState(""); 
    const [selectedCountry, setSelectedCountry] = useState(""); 
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");


    const [cart, setCart] = useState({
        items: [],
        totalAmount: 0,
        tax: 0,
        netAmount: 0,
        suggestion:''
    });
    


    // Function to determine if a field is editable
    const isFieldEditable = (fieldName) => editableFields[fieldName];

    useEffect(() => {
        const fetchCustomerData = async () => {
            try {
                const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                if (!userInfo?.customerId) {
                    console.error("User info not found.");
                    return;
                }

                const response = await Axios.get(`/customer/get/${userInfo.customerId}`, {
                    headers: { Authorization: `Bearer ${userInfo.token}` },
                });

                const customerData = response.data || {};

                setCustomer({
                    customerName: customerData.customerName || "",
                    phoneNumber: customerData.phoneNumber || "",
                    email: customerData.email || "",
                    username:customerData.username || "",
                    gstNumber: customerData.gstNumber || "",
                    address: customerData.address || "",
                    country: customerData.country || "",
                    state: customerData.state || "",
                    city: customerData.city || "",
                    pincode: customerData.pincode || "",
                    bankName: customerData.bankName || "",
                    bankAddress: customerData.bankAddress || "",
                    accountNumber: customerData.accountNumber || "",
                    currency: customerData.currency || "",
                    ibanNumber: customerData.ibanNumber || "",
                    swift: customerData.swift || ""

                });

                setSelectedCountry(customerData.country || "");
                if (customerData.shippingOption) {
                  setShippingOption(customerData.shippingOption);
                }


                // Determine which fields should be editable (if initially empty)
                setEditableFields({
                    customerName: !customerData.customerName,
                    phoneNumber: !customerData.phoneNumber,
                    email: !customerData.email,
                    username: !customerData.username,
                    gstNumber: !customerData.gstNumber,
                    address: !customerData.address,
                    country: !customerData.country,
                    state: !customerData.state,
                    city: !customerData.city,
                    pincode: !customerData.pincode,
                    bankName: !customerData.bankName,
                    bankAddress: !customerData.bankAddress,
                    accountNumber: !customerData.accountNumber,
                    currency: !customerData.currency,
                    ibanNumber: !customerData.ibanNumber,
                    swift: !customerData.swift



                });

            } catch (error) {
                console.error("Error fetching customer data:", error);
            }
        };

        fetchCustomerData();
    }, []);

    

    const clearCart = async () => {
       
    
        if (!cart?._id) {
          console.error("Cart ID is missing!");
          return;
        }
    
        try {
          console.log(`Clearing cart with ID: ${cart._id}`);
          const res = await Axios.delete(`/cart/${cart._id}`);
    
          // Update state: Reset cart
          setCart({
            items: [],
            totalAmount: 0,
            tax: 0,
            netAmount: 0,
            suggestion:''
          });
        } catch (error) {
          console.error("Error clearing cart:", error.response?.data?.message || error.message);
        }
      };
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setCustomer((prevCustomer) => {
            if (isFieldEditable(name)) {
                return { ...prevCustomer, [name]: value };
            }
            return prevCustomer;
        });
    };

    const handleCountryChange = (e) => {
        setSelectedCountry(e.target.value);
    };

    const handleShippingChange = (e) => {
        setShippingOption(e.target.value);
    };


    // Submit updated data to backend
    const handleSubmit = async () => {
        try {
            setIsLoad(true); // Start loading
    
            const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            const businessType = sessionStorage.getItem("businessType");
    
            if (!userInfo?.customerId) {
                alert("User info not found. Please log in again.");
                setIsLoad(false);
                return;
            }
            console.log("Selected country:", selectedCountry);
            console.log("Selected shipping option:", shippingOption);

    
           if (!shippingOption) {
  setModalMessage("Please select a shipping option.");
  setShowModal(true);
  setIsLoad(false);
  return;
}

if (!selectedCountry) {
  setModalMessage("Please select a country.");
  setShowModal(true);
  setIsLoad(false);
  return;
}


          
    
        if (!cart || cart.items.length === 0) {
    setModalMessage("Your cart is empty!");
    setShowModal(true);
    setIsLoad(false);
    return;
}

    
            const updatedCustomer = {
                customerName: customer.customerName || "",
                phoneNumber: customer.phoneNumber || "",
                email:customer.email || "",
                username:customer.username || "",
                gstNumber: customer.gstNumber || "",
                address: customer.address || "",
                country: selectedCountry,
                state: customer.state || "",
                city: customer.city || "",
                pincode: customer.pincode || "",
                shippingOption: shippingOption,
                bankName: customer.bankName || "",
                bankAddress: customer.bankAddress || "",
                accountNumber: customer.accountNumber || "",
                currency: customer.currency || "",
                ibanNumber: customer.ibanNumber || "",
                swift: customer.swift || ""
            };
    
            await Axios.put(`/customer/update/${userInfo.customerId}`, updatedCustomer, {
                headers: { Authorization: `Bearer ${userInfo.token}` }
            });
    
            const orderNumberResponse = await Axios.get(`/order/lastOrderNumber`);
            const lastOrderNumber = orderNumberResponse.data.lastOrderNumber || 99;
            const newOrderNumber = lastOrderNumber + 1;
    
            const orderData = {
                customerId: userInfo?.customerId,
                customerName: customer.customerName || "",
                customerEmail:customer.email,
                orderNumber: newOrderNumber,
                shipping: shippingOption,
                country: selectedCountry,
                orderDate: new Date().toISOString().split("T")[0],
                deliveryDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
                orderStatus: "quotation requested",
                paymentStatus: "Pending",
                totalAmount: cart.totalAmount,
                currency: "AED",
                tax: cart.tax,
                suggestion:cart.suggestion,
                netAmount: cart.netAmount,
                businessType: businessType || "Unknown",
            orderItems: cart.items.map(item => ({
  productId: item.productId,
  supplierId: typeof item.supplierId === 'object' ? item.supplierId.supplierId : item.supplierId,
  productType: item.productType,
  productName: item.productName,
  partNo: item.partNo,
  brand: item.brand?.name || "",             
  brandId: item.brand?._id || null,

  quantity: item.quantity,
  unitPrice: item.unitPrice,
  totalPrice: item.totalItemPrice,

  // ✅ Add rental fields
  rentStartDate: item.rentStartDate || null,
  rentEndDate: item.rentEndDate || null,
  rentalDays: item.rentalDays || 1,
  rentalPrice: item.rentalPrice || 0,
}))

            };

            const orderResponse = await Axios.post("/order/create", orderData);

            const { newOrder, orderItemsWithSuppliers } = orderResponse.data;

// Call API to send supplier emails
await Axios.post("/sendSupplierEmails", {
  orderNumber: newOrder.orderNumber,
  orderItems: orderItemsWithSuppliers
});


            
            console.log("Order Response:", orderResponse.data);
            
            await clearCart(); 
            setTimeout(() => {
                navigate("/");
            }, 2000);
        } catch (error) {
            console.error("Error placing order:", error);
            // alert("Something went wrong. Please try again.");
        } finally {
            setTimeout(() => setIsLoad(false), 5000);
        }
    };
    
    
    
    

    useEffect(() => {
        const fetchCartData = async () => {
            try {
                const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                if (!userInfo?.customerId) {
                    console.error("User info not found.");
                    return;
                }
    
                const response = await Axios.get(`/cart/${userInfo.customerId}`, {
                    headers: { Authorization: `Bearer ${userInfo.token}` },
                });
    
                // console.log("Cart Data:", response.data); // Debugging
                // if (response.data) {
                //     setCart(response.data);

                 // Retrieve businessType from session storage
      const businessType = (sessionStorage.getItem("businessType") || "").toLowerCase();

// Filter cart items based on normalized businessType
const filteredCart = {
  ...response.data,
  items: response.data?.items?.filter(item =>
    item.productType.some(pt => pt.toLowerCase() === businessType)
  ) || [],
};

// Recalculate totalAmount based on filtered items
filteredCart.totalAmount = filteredCart.items.reduce((sum, item) => sum + item.totalItemPrice, 0);

setCart(filteredCart);

                
            } catch (error) {
                console.error("Error fetching cart data:", error);
            }
        };
    
        fetchCartData();
    }, []);

    
   const style = {
     fontFamily: "'Poppins', sans-serif",
     position: 'relative',
     fontWeight: 700,
     color: '#353C4B',
   };

   return (
     <div>
       <Header />
       <section class="delivery_payments">
         <div class="container">
           {/* <h4>Delivery & payment</h4> */}

           <div class="row mt_48" style={{ marginTop: "150px" }}>
             <div class="col-md-6">
               <h6>ORDER DELIVERY</h6>
               {/* Country Dropdown */}
               <div className="form-group">
                 <label htmlFor="country">Country</label>
                 <select
                   className="form-control selectDropDown"
                   id="country"
                   name="country"
                   value={selectedCountry}
                   onChange={handleCountryChange}
                   disabled={!isFieldEditable("country")}
                 >
                   <option value="">Select your country</option>
                   <option value="United Arab Emirates">
                     United Arab Emirates
                   </option>
                   <option value="India">India</option>
                   <option value="Saudi Arabia">Saudi Arabia</option>
                   <option value="Qatar">Qatar</option>
                   <option value="Oman">Oman</option>
                   <option value="Kuwait">Kuwait</option>
                 </select>
               </div>

               {/* <div className="form-group">
                 <label htmlFor="country">Country</label>
                 <input
                   type="text"
                   className="form-control"
                   id="country"
                   name="country"
                   value={customer.country}
                   onChange={handleChange}
                   placeholder="Enter your Country"
                   disabled={!isFieldEditable('country')}
                 />
               </div> */}

               {/* Shipping Option Dropdown */}
               <div className="form-group">
                 <label htmlFor="shippingOption">Shipping option*</label>
                 <select
                   className="form-control selectDropDown"
                   id="shippingOption"
                   value={shippingOption}
                   onChange={handleShippingChange}
                 >
                   <option value="">Select a shipping option</option>
                   <option value="Collection by your own courier">
                     Collection by your own courier
                   </option>
                   <option value="Standard Shipping">Standard Shipping</option>
                   <option value="Express Shipping">Express Shipping</option>
                   <option value="Overnight Shipping">
                     Overnight Shipping
                   </option>
                 </select>
               </div>

        <div>
  <div>
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
        className="shippingAddress"
      >
        <h6
          style={{
            margin: 0,
            fontSize: "20px",
            fontWeight: "600",
            color: "#2d3748",
          }}
        >
          Shipping Address
        </h6>

        {/* Expand/Collapse Button */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="btn btn-sm btn-outline-primary d-flex align-items-center"
          style={{ borderRadius: "20px" }}
        >
          {isExpanded ? (
            <>
              Collapse <FaChevronUp className="ms-2" style={{ color: "#2d3748",}}/>
            </>
          ) : (
            <>
              View <FaChevronDown className="ms-2" style={{ color: "#2d3748",}}/>
            </>
          )}
        </button>
      </div>

   
    </div>

      {/* Always Visible Fields */}
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="customerName">Name</label>
            <input
              type="text"
              className="form-control"
              id="customerName"
              name="customerName"
              value={toTitleCase(customer.customerName)}
              onChange={handleChange}
              placeholder="Enter Name"
              disabled={!isFieldEditable("customerName")}
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number</label>
            <input
              type="text"
              className="form-control"
              id="phoneNumber"
              name="phoneNumber"
              value={toTitleCase(customer.phoneNumber)}
              onChange={handleChange}
              placeholder="Enter Phone number"
              disabled={!isFieldEditable("phoneNumber")}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="city">City</label>
            <input
              type="text"
              className="form-control"
              id="city"
              name="city"
              value={toTitleCase(customer.city)}
              onChange={handleChange}
              placeholder="Enter your City"
              disabled={!isFieldEditable("city")}
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="address">Street Address</label>
            <input
              type="text"
              className="form-control"
              id="address"
              name="address"
              value={customer.address}
              onChange={handleChange}
              placeholder="Enter your Street Address"
              disabled={!isFieldEditable("address")}
            />
          </div>
        </div>
      </div>

      {/* Expand/Collapse Button */}
     

      {/* Collapsible Additional Fields */}
      <div
        style={{
          maxHeight: isExpanded ? "2000px" : "0",
          overflow: "hidden",
          transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
          opacity: isExpanded ? 1 : 0
        }}
      >
        <div style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          borderRadius: "12px",
          marginBottom: "20px",
          border: "2px solid #e2e8f0"
        }}>
          <h6 style={{ 
            fontSize: "16px", 
            fontWeight: "600", 
            color: "#000000ff",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <span>👤</span> Account Information
          </h6>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="userName">UserName</label>
                <input
                  type="text"
                  className="form-control"
                  id="userName"
                  name="username"
                  value={customer.username}
                  onChange={handleChange}
                  placeholder="Enter UserName"
                  disabled={!isFieldEditable("Username")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="Email">Email</label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  name="email"
                  value={customer.email}
                  onChange={handleChange}
                  placeholder="Enter Email"
                  disabled={!isFieldEditable("Email")}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="gstNumber">GST Number / Personal ID</label>
                <input
                  type="text"
                  className="form-control"
                  id="gstNumber"
                  name="gstNumber"
                  value={customer.gstNumber}
                  onChange={handleChange}
                  placeholder="Enter GST Number / Personal ID"
                  disabled={!isFieldEditable("gstNumber")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  className="form-control"
                  id="country"
                  name="country"
                  value={toTitleCase(customer.country)}
                  onChange={handleChange}
                  placeholder="Enter your Country"
                  disabled={!isFieldEditable("country")}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="state">State / Region</label>
                <input
                  type="text"
                  className="form-control"
                  id="state"
                  name="state"
                  value={toTitleCase(customer.state)}
                  onChange={handleChange}
                  placeholder="Enter your State / Region"
                  disabled={!isFieldEditable("state")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="pincode">Pincode</label>
                <input
                  type="text"
                  className="form-control"
                  id="pincode"
                  name="pincode"
                  value={customer.pincode}
                  onChange={handleChange}
                  placeholder="Enter your Pincode"
                  disabled={!isFieldEditable("pincode")}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{
          padding: "20px",
          backgroundColor: "#f0fdf4",
          borderRadius: "12px",
          marginBottom: "20px",
          border: "2px solid #ffffffff"
        }}>
          <h6 style={{ 
            fontSize: "16px", 
            fontWeight: "600", 
            color: "#000000ff",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <span>🏦</span> Banking Information
          </h6>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="bankName">Bank Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="bankName"
                  name="bankName"
                  value={toTitleCase(customer.bankName)}
                  onChange={handleChange}
                  placeholder="Enter Bank Name"
                  disabled={!isFieldEditable("bankName")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="bankAddress">Bank Address</label>
                <input
                  type="text"
                  className="form-control"
                  id="bankAddress"
                  name="bankAddress"
                  value={toTitleCase(customer.bankAddress)}
                  onChange={handleChange}
                  placeholder="Enter Bank Address"
                  disabled={!isFieldEditable("bankAddress")}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="accountNumber">Account Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="accountNumber"
                  name="accountNumber"
                  value={customer.accountNumber}
                  onChange={handleChange}
                  placeholder="Enter Account Number"
                  disabled={!isFieldEditable("accountNumber")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="currency">Currency</label>
                <input
                  type="text"
                  className="form-control"
                  id="currency"
                  name="currency"
                  value={customer.currency}
                  onChange={handleChange}
                  placeholder="Enter Currency"
                  disabled={!isFieldEditable("currency")}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="ibanNumber">IBAN Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="ibanNumber"
                  name="ibanNumber"
                  value={customer.ibanNumber}
                  onChange={handleChange}
                  placeholder="Enter IBAN Number"
                  disabled={!isFieldEditable("ibanNumber")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="swift">SWIFT Code</label>
                <input
                  type="text"
                  className="form-control"
                  id="swift"
                  name="swift"
                  value={customer.swift}
                  onChange={handleChange}
                  placeholder="Enter SWIFT Code"
                  disabled={!isFieldEditable("swift")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
             </div>

             <div class="col-md-6 orderSummary">
               <h6 style={style}>Order Summary</h6>

               {cart.items.length > 0 ? (
                 cart.items.map((item, index) => (
                   <div className="row" key={index}>
                     <div className="col-md-6">
                       <p className="boldText">{item.productName}</p>
                       <p>{item.partNo}</p>
                     </div>
                     <div className="col-md-3">
                       <p className="orderContent">Quantity: {item.quantity}</p>
                     </div>
                     <div className="col-md-3">
                       {/* <p className="orderNum">AED {item.totalItemPrice}</p> */}
                     </div>
                     <hr />
                   </div>
                 ))
               ) : (
                 <p>No items in cart</p>
               )}

               <div className="row mt-5">
                 <div className="col-md-6"></div>
                 <div className="col-md-6 orderTotal">
                   <div style={{ display: "flex" }}>
                     <h6>Total Items:</h6>
                     <span className="alreadyUsed">{cart.items.length}</span>
                   </div>
                   {/* <div style={{ display: "flex" }}>
                <h6>Subtotal:</h6>
                <span className="alreadyUsed">AED {cart.totalAmount}</span>
            </div> */}
                   <div style={{ display: "flex" }}>
                     <h6>Tax:</h6>
                     <span className="alreadyUsed"> 5%</span>
                   </div>
                   {/* <div style={{ display: "flex" }}>
                     <div className="alreadyUsed orderTotalCost">
                       <p>Total:</p>
                       <h3 className="totalRedClr">AED -</h3>
                     </div>
                   </div> */}
                   {isLoad === true ? (
                     <ConfettiButton />
                   ) : (
                     <div class="OrderSummarycontinueBtn">
                       <button
                         className="orderContinueBtn p-2"
                           onClick={handleSubmit}
                           
                       >
                         Submit Order
                       </button>
                     </div>
                   )}
                 </div>
               </div>
             </div>
           </div>
         </div>
       </section>

       {/* <Footer /> */}
       {/* {showModal && (
         <div
           style={{
             position: "fixed",
             top: 0,
             left: 0,
             width: "100%",
             height: "100%",
             background: "rgba(0, 0, 0, 0.5)",
             zIndex: 9999,
             display: "flex",
             alignItems: "center",
             justifyContent: "center",
           }}
         >
           <div
             style={{
               background: "#fff",
               padding: "20px 30px",
               borderRadius: "8px",
               textAlign: "center",
               maxWidth: "400px",
               width: "90%",
             }}
           >
             <p style={{ marginBottom: "20px" }}>{modalMessage}</p>
             <button
               onClick={() => setShowModal(false)}
               style={{
                 padding: "8px 20px",
                 backgroundColor: "#003366",
                 color: "#fff",
                 border: "none",
                 borderRadius: "4px",
                 cursor: "pointer",
               }}
             >
               Close
             </button>
           </div>
          

         </div>
         
       )} */}
       <AlertModal
  isOpen={showModal}
  message={modalMessage}
  onClose={() => setShowModal(false)}
/>

     </div>
     
   );
}

export default Delivery
